export default __webpack_public_path__ + "static/media/SAS0360.34I-41996_-25148_0.c39ce451.jpg";